import { COUNTRIES } from "@/components/home/data";

export const DEFAULT_CC = "+91";
const country = (cc) => COUNTRIES.find((c) => c.code === cc);

/* Normalisation helpers shared by every login form and the chat verify card */
export const composeMobile = ({ cc, local }) => `${cc || DEFAULT_CC}${(local || "").replace(/\D/g, "")}`;
export const phoneValid = ({ cc, local }) => {
  const d = (local || "").replace(/\D/g, "");
  const c = country(cc);
  if (!c) return d.length >= 6 && d.length <= 12;
  const min = c.min ?? c.len ?? 6, max = c.max ?? c.len ?? 12;
  return d.length >= min && d.length <= max;
};
export const splitMobile = (raw) => {
  const s = (raw || "").replace(/[^\d+]/g, "");
  if (!s.startsWith("+")) return { cc: DEFAULT_CC, local: s.replace(/\D/g, "").slice(-10) };
  const hit = [...COUNTRIES].sort((a, b) => b.code.length - a.code.length).find((c) => s.startsWith(c.code));
  return hit ? { cc: hit.code, local: s.slice(hit.code.length) } : { cc: DEFAULT_CC, local: s.slice(1) };
};
const hint = (cc) => { const c = country(cc); if (!c) return ""; const n = c.len ?? (c.min === c.max ? c.min : null); return n ? `${n} digits` : `${c.min}–${c.max} digits`; };

export const PhoneInput = ({ value, onChange, testId = "phone", label, variant = "box", required = true, autoFocus = false, disabled = false, placeholder = "Mobile number" }) => {
  const v = value || { cc: DEFAULT_CC, local: "" };
  const underline = variant === "underline";
  const box = "bg-white border border-[#1A2E26]/15 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-[#1A2E26]/50 focus:ring-2 focus:ring-[#1A2E26]/10 transition-colors";
  const line = "bg-transparent border-b border-border py-2.5 outline-none focus:border-accent";
  const cls = underline ? line : box;
  const bad = v.local && !phoneValid(v);
  return (
    <div data-testid={`${testId}-group`}>
      {label && <span className="block text-[11px] font-medium text-[#1A2E26]/70 mb-1">{label}</span>}
      <div className="flex gap-2">
        <select data-testid={`${testId}-cc`} aria-label="Country code" disabled={disabled} value={v.cc} onChange={(e) => onChange({ ...v, cc: e.target.value })} className={`${cls} w-[7.5rem] shrink-0 pr-6`}>
          {COUNTRIES.map((c) => <option key={c.code + c.name} value={c.code}>{c.flag} {c.code}</option>)}
        </select>
        <input data-testid={`${testId}-number`} type="tel" inputMode="numeric" autoComplete="tel-national" autoFocus={autoFocus} required={required} disabled={disabled} maxLength={12} value={v.local}
          onChange={(e) => onChange({ ...v, local: e.target.value.replace(/\D/g, "") })} placeholder={placeholder} className={`${cls} flex-1 min-w-0 placeholder:text-[#1A2E26]/35 ${bad ? (underline ? "border-rose-400" : "border-rose-400") : ""}`} />
      </div>
      <p className={`mt-1 text-[11px] ${bad ? "text-rose-600" : "text-[#1A2E26]/50"}`} data-testid={`${testId}-hint`}>{bad ? `Please enter a valid number (${hint(v.cc)})` : `${country(v.cc)?.name || "Country"} · ${hint(v.cc) || "mobile number without country code"}`}</p>
    </div>
  );
};
